import { useState } from "react";
import { FaTriangleExclamation } from "react-icons/fa6";
import { TicketService } from "../../../services/TicketService";
import { ModalWraper } from "../../../components/modal/wraper";

export const TicketDelete = ({ open, setOpen, refreshData, targetId }) => {
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        if (!targetId) return;

        try {
            setLoading(true);
            // Panggil Service Delete
            await TicketService.delete({ id: targetId });
            
            if (refreshData) refreshData();
            setOpen(false);
        } catch (error) {
            console.error("Gagal menghapus tiket:", error);
            alert("Gagal menghapus tiket.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <ModalWraper
            isOpen={open}
            setIsOpen={setOpen}
            title="Hapus Tiket"
            maxWidth={"md:max-w-md"}
            icon={<FaTriangleExclamation className="text-red-500" />}
        >
            <div className="text-center py-4">
                <div className="w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center mx-auto mb-4 border border-red-500/20">
                    <FaTriangleExclamation className="text-3xl text-red-500" />
                </div>
                <h3 className="text-lg font-bold text-gray-100 mb-2">
                    Apakah Anda yakin?
                </h3>
                <p className="text-slate-400 text-sm leading-relaxed">
                    Tindakan ini akan menghapus data tiket secara permanen. 
                    Data yang dihapus tidak dapat dikembalikan lagi.
                </p>
            </div>

            <div className="flex gap-3 mt-6">
                <button
                    type="button"
                    onClick={() => setOpen(false)}
                    disabled={loading}
                    className="flex-1 py-3 rounded-xl border border-slate-700 text-slate-300 transition-colors hover:bg-slate-800 disabled:opacity-50"
                >
                    Batal
                </button>
                <button
                    onClick={handleDelete}
                    disabled={loading}
                    className="flex-1 py-3 rounded-xl bg-red-600 hover:bg-red-500 disabled:bg-slate-700 text-white font-semibold flex items-center justify-center gap-2 transition-colors"
                >
                    {loading ? "Menghapus..." : "Ya, Hapus"}
                </button>
            </div>
        </ModalWraper>
    );
};